import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { actions } from 'react-redux-form'
import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronUp, faWheelchair } from '@fortawesome/free-solid-svg-icons'
import clsx from 'clsx'
import { ButtonLink } from '../../utils/Button'

import { SITE_TYPES } from '../../../utils/constants'
import { Join } from '../../utils/Join'

dayjs.extend(localeData)

const SitesHeader = ({ loop, sitesCount, onClick, expanded }) => {
  const isReactSnap = navigator.userAgent === 'ReactSnap'

  return (
    <div className="border-b-2 border-green-200 px-1 cursor-pointer flex" onClick={onClick}>
      <div className="flex-grow flex">
        <span className="text-3xl font-semibold mr-6">{loop.name}</span>
        <div className="self-end mb-1 flex space-x-2 text-sm text-gray-600">
          <span className="">Sites: {sitesCount}</span>
          <span>&#183;</span>
          <span className="">
            <Join
              items={Object.keys(loop.types || []).map(type => (
                <React.Fragment key={type}>
                  {SITE_TYPES[type] || type}: {loop.types[type]}
                </React.Fragment>
              ))}
            />
          </span>
          <span>&#183;</span>
          <span className="">
            <Join
              items={[
                loop.electricCount && <>Electric: {loop.electricCount}</>,
                loop.waterCount && <>Water: {loop.waterCount}</>,
                loop.sewerCount && <>Sewer: {loop.sewerCount}</>
              ]}
            />
          </span>
        </div>
      </div>
      <div className="flex-initial">
        <FontAwesomeIcon icon={isReactSnap || expanded ? faChevronUp : faChevronRight} className="text-4xl pb-2" />
      </div>
    </div>
  )
}

const Sites = () => {
  const dispatch = useDispatch()
  const sites = useSelector(store => store.availabilityRequests.sites)
  const facility = useSelector(store => store.facilities.facility)
  const isReactSnap = navigator.userAgent === 'ReactSnap'
  const [siteStartsWith, setSiteStartsWith] = useState()

  const [loopExpanded, setLoopExpanded] = useState([])

  const toggleLoopExpanded = loop => {
    setLoopExpanded(loopExpanded.includes(loop) ? loopExpanded.filter(d => d !== loop) : loopExpanded.concat([loop]))
  }

  const filteredSites = useCallback(
    loop => {
      if (!siteStartsWith) {
        return sites.filter(site => site.loop === loop.name)
      }

      return sites.filter(
        site =>
          site.loop === loop.name &&
          (site.siteNum.startsWith(siteStartsWith) || site.siteNum.replace(/^0+/, '').startsWith(siteStartsWith))
      )
    },
    [sites, siteStartsWith]
  )

  return (
    <div className="">
      {facility.sitesDetails.loopsArray && (
        <div className={`mt-6`}>
          <div className="">
            {facility.sitesDetails.loopsArray.map(loop => (
              <div key={loop.name} className={`mb-6 mt-6 ${filteredSites(loop).length > 0 ? '' : 'hidden'}`}>
                {facility.sitesDetails.loopsArray.length > 1 && (
                  <SitesHeader
                    loop={loop}
                    sitesCount={filteredSites(loop).length}
                    onClick={() => toggleLoopExpanded(loop)}
                    expanded={loopExpanded.includes(loop)}
                  />
                )}

                <div
                  className={`m-4 space-x-2-right space-y-2 ${
                    isReactSnap || loopExpanded.includes(loop) || facility.sitesDetails.loopsArray.length < 2
                      ? ''
                      : 'hidden'
                  }`}
                >
                  {filteredSites(loop).map(site => (
                    <div key={site.id} className={`flex px-3 py-1 rounded-md border`}>
                      <div className="flex flex-grow items-center space-x-12">
                        <span className="text-3xl font-bold  text-gray-700">{site.siteNum}</span>

                        <div className="text-gray-500 grid grid-rows-2 grid-flow-col gap-2 gap-x-8">
                          <span>
                            Type: {site.siteTypeText} {site.siteLayoutText && '/'} {site.siteLayoutText}
                          </span>
                          <span>{site.length && <>Length: {site.length}'</>}</span>
                          <span>Water: {site.water ? 'Yes' : 'No'}</span>
                          <span>Sewer: {site.sewer ? 'Yes' : 'No'}</span>
                          {site.electric && <span>{site.electric} Amp Service</span>}
                          {site.premium && <span>Premium Site</span>}
                        </div>
                        {site.ada && <FontAwesomeIcon icon={faWheelchair} className="text-2xl" />}
                      </div>
                      <ButtonLink to={`/f/${facility.id}/s/${site.id}`}>More</ButtonLink>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Sites

{
  /* <div className="flex items-end space-x-12 border-b-2 border-green-500 pb-4">
<div>
  <label className="filter-label inline">Sites</label>
</div>

<span className="font-semibold text-gray-700 px-2 py-1 bg-green-200 rounded-md">
  {sites.length}
  <span className=""> Available</span>
</span>

<input
  className="appearance-none border border-gray-400 rounded py-2 px-3 text-gray-700 leading-tight placeholder-opacity-50 w-48 bg-gray-100"
  placeholder="Filter By Site Name"
  type="text"
  onChange={e => setSiteStartsWith(e.target.value)}
/>
</div> */
}
